import React from 'react';
import { Button } from 'nike-ui/src/components/button/Button';

import i18n from '@i18n';
import FacebookNoCircleIcon from 'nike-ui/src/icons/svg/facebook-no-circle-icon-sv.svg';
import ShareTicketIcon from 'nike-ui/src/icons/svg/share-ticket-icon-sv.svg';
import { getConfigProperty } from '@/common/oldMobile';
import PopupNg from '@/ui/PopupNg';
import { createNikeTicketShareURL } from 'nike-ui/src/common/util';

export function shareTicket(e, ticket) {
    PopupNg.dispatcher.close('ticketDetail');
    PopupNg.dispatcher.close('betbook/ticketDetailPopup');
    e.preventDefault();
    e.stopPropagation();
    const { alias, hash } = ticket;

    const href = createNikeTicketShareURL(
        `https://www.nike.sk/${alias ? 'tiket-alias' : 'tiket'}/${alias ? alias : hash}`,
        ticket.hash,
        navigator.share ? 'navigator' : 'facebook'
    );

    if (navigator.share) {
        navigator.share({ url: href });
    } else {
        const appId = getConfigProperty('facebook.key');
        // natvrdo produkcna scrap url, nema vyznam tu davat testovacie hosty, ked sa facebook z vonka na ne aj tak nedostane

        const hashtag = encodeURIComponent('#NikeFandisNaplno');
        const url = `https://www.facebook.com/dialog/share?app_id=${appId}&display=touch&href=${encodeURIComponent(
            href
        )}&hashtag=${hashtag}`;
        // const appId = getConfigProperty('facebook.key');
        // // natvrdo produkcna scrap url, nema vyznam tu davat testovacie hosty, ked sa facebook z vonka na ne aj tak nedostane
        // const href = encodeURIComponent(`https://www.nike.sk/tiket/${ticketHash}/`);
        // const hashtag = encodeURIComponent('#NikeFandisNaplno');
        // const url = `https://www.facebook.com/dialog/share?app_id=${appId}&display=touch&href=${href}&hashtag=${hashtag}`;
        window.open(url, '_blank');
    }
}

export default function Share({ ticket }) {
    return (
        <Button
            className="blue"
            dataAtid={navigator.share ? 'ticket-detail-share' : 'ticket-detail-fb-share'}
            icon={navigator.share ? ShareTicketIcon : FacebookNoCircleIcon}
            label={navigator.share ? i18n('tiket.detailTiketu.share') : i18n('tiket.detailTiketu.shareFB')}
            onClick={e => {
                shareTicket(e, ticket);
            }}
        />
    );
}
